import { RecordFactory } from '.'
import type { RecordStrategy, RecordStrategyArgs } from '../types'
import { useSpace } from '@/store/modules/App/space'

export class StoryRecord implements RecordStrategy {
  async set(args: RecordStrategyArgs = {}): Promise<void> {
    const { spaceId, storyId } = args
    const { isBlockedOrUnpaid } = useSpace()

    if (!spaceId || !storyId || isBlockedOrUnpaid) {
      this.remove()
      return
    }
    window?.CommandBar?.addMetadata('storyId', storyId)
    this.setRecords(args)
  }

  async remove(): Promise<void> {
    window?.CommandBar?.addMetadata('storyId', undefined)
    await RecordFactory.getRecord('blocks').remove!()
  }

  async setRecords(args: RecordStrategyArgs = {}): Promise<void> {
    await RecordFactory.getRecord('blocks').set!(args)
  }
}
